import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { Layout } from "@circle-react/components/shared/CustomizeUI";
import { Tabs } from "@circle-react-uikit/Tabs";
import { FilesTab } from "./FilesTab";
import { GeneralTab } from "./GeneralTab";

export const Sidebar = () => {
  const TABS = {
    GENERAL: t(`courses.edit.lesson.tabs.general.title`),
    FILES: t(`courses.edit.lesson.tabs.files.title`),
  };

  const [currentTab, setCurrentTab] = useState(TABS.GENERAL);
  const options = Object.values(TABS).map(tabName => ({ label: tabName }));

  const tabComponentMap = {
    [TABS.GENERAL]: GeneralTab,
    [TABS.FILES]: FilesTab,
  };

  const TabComponent = tabComponentMap[currentTab];

  return (
    <Layout.Sidebar className="hidden !w-[336px] px-6 md:block">
      <Tabs
        variant="underline-sm"
        controlled
        activeTab={currentTab}
        onClick={setCurrentTab}
        options={options}
      />
      <TabComponent />
    </Layout.Sidebar>
  );
};
